<!--
 * @Author: your name
 * @Date: 2021-11-11 12:50:34
 * @LastEditTime: 2022-05-04 21:58:53
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\views\home.vue
-->
<template>
    <div>
        <van-sticky>
            <navbar v-if="!getOpenInWechat"></navbar>
        </van-sticky>
        <router-view id="layout"></router-view>
        <tabbar v-if="getTabbarItem.isShow && isShow"></tabbar>
    </div>
</template>
<script>
import navbar from '@/components/mini-navbar/index.vue'
import tabbar from '@/components/mini-tabbar/index.vue'
export default {
    components: {
        navbar,
        tabbar
    },
    data() {
        return {
            docmHeight: this.$store.state.app.winHeight,  //默认屏幕高度       
            showHeight:  '0',   //实时屏幕高度        
            hidshow: true,  //显示或者隐藏footer,      
            isResize: false //默认屏幕高度是否已获取   
        }
    },
    mounted() {
        window.onresize = ()=>{        
            return(()=>{                     
                if (!this.isResize) {                          
                    this.isResize = true                       
                }                        
                // 实时屏幕高度                       
                this.showHeight = document.body.clientHeight         
            })()    
        }
    },
    computed: {
        getTabbarItem () {
            return this.$store.state.app.tabbar
        },
        getOpenInWechat() {
            return this.$store.state.app.system.openInWechat
        },
        isShow() {
            return this.hidshow
        },
    },
    watch: {
        showHeight: function() {        
            if(this.docmHeight > this.showHeight){            
                this.hidshow = false        
            }else{            
                this.hidshow = true        
            }    
        }
    },
    created() {
    },
    methods: {
    },
}
</script>
<style lang="less" scoped>
</style>